import React from "react";
import { connect } from "react-redux";
import { callService, goTo } from "../tools";
import { validarPass, aceptoContrato, validarCorreo } from "./services.act.js";
import { authentication } from "../app-database";
import { servicios } from "../properties.js";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import { Field, reduxForm } from "redux-form";
import "./gnp-login.css";
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';
import CintilloNuevo from '../mensajes-tooltips/mensaje-nuevoportal.cmpt.js';

const modalNuevoDesbloqueado = "#modal-nuevo-bloqueado";
const modalErrorDesbloqueo = "#modal-error-desbloqueo";
const mensaje1 = "Su cuenta ha sido temporalmente bloqueada.";
const mensaje2 = "Por su seguridad conteste las preguntas secretas para continuar.";
const mensaje3 = "Si lo prefieres puedes llamarnos al 55 5227 9000, en la opción 7 de lunes a viernes de 8:00 a 20:00 horas y" +
	"sábados de 8:00 a 14:00 horas donde con gusto te atenderemos.";
const TemporizadoOTP = "TemporizadoOTP";
const nombreModalOTP = "#modal-OTP";
const idModal = "#modal-otp";
let totalSeconds = 420;


const mapState = (state) => {
	return {
		cveCliente: state.login.cveCliente,
		correo: state.login.correo,
		secreto: state.login.secreto,
		intento: state.login.intento,
		pUno: state.login.pUno,
		pUnoText: state.login.pUnoText,
		pDos: state.login.pDos,
		pDosText: state.login.pDosText,
		hashOne: state.registroAF.hashOne,
		hashTwo: state.registroAF.hashTwo,
		accesoFamiliar: state.login.accesoFamiliar,
		uid: state.login.uid,
		email: state.login.correo,
		pass: state.login.contrasena,
		dispositivo: state.global.dispositivo,
		error: state.login.error,
		mensaje: state.login.errorMsj,
		mensajePwd: state.login.errorMsjPwd,
		loader: state.global.loader
	};
};

const mapDispatch = (dispatch) => {
	return {
		setClaveCliente: (uid) => {
			dispatch({ "type": "LOGIN_SET_UID", "uid": uid });
		},
		setPaso: (paso) => {//REVISAR
			dispatch({ "type": "LOGIN_SET_PASO", "paso": paso });
		},
		resetAccesoFamiliar: () => {
			dispatch({ "type": "LOGIN_SET_ACCESO_FAMILIAR", "accesoFamiliar": false });
		},
		resetPaso: () => {//REVISAR
			dispatch({ "type": "LOGIN_RESET_PASO" });
		},
		incrementaIntento: () => {
			dispatch({ "type": "LOGIN_INCREMENTA_INTENTO" });
		},
		eventoCorrectos: (dispositivo) => {
			dispatch({ "type": "EVENT_LOGIN_BIENVENIDO_CORRECTOS", "flujo": "login", "dispositivo": dispositivo });
		},
		aviso: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "IMPORTANTE", "mensaje": sMensaje });
		},
		alertaAccion: (sMensaje, fnAccion) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": "ERROR", "mensaje": sMensaje, "accion": fnAccion });
		},
		setPass: (pass) => {
			dispatch({ "type": "LOGIN_SET_CONTRASENA", "contrasena": pass });
		},
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		addEvento: (evento) => {
			dispatch({ "type": "LOGIN_SET_EVENT", "evento": evento });
		},
		pasoSiguiente: (correo, disp) => {
			dispatch(validarCorreo(correo, disp));
		},
		pasoPreguntas: () => {
			dispatch({ "type": "LOGIN_PASO_SIGUIENTE" });
		},
		setCorreo: (correo) => {
			dispatch({ "type": "LOGIN_SET_CORREO", "correo": correo });
		},
		clearSecreto: () => {
			dispatch({ "type": "LOGIN_SET_SECRETO", "secreto": "" });
		},
		setSecreto: (secreto) => {
			dispatch({ "type": "LOGIN_SET_SECRETO", "secreto": secreto });
		},
		setPreguntaUno: (obj) => {
			dispatch({ "type": "LOGIN_SET_PREGUNTA_UNO", texto: obj.t, id: obj.id });
		},
		setPreguntaDos: (obj) => {
			dispatch({ "type": "LOGIN_SET_PREGUNTA_DOS", texto: obj.t, id: obj.id });
		},
		showLoader: () => {
			dispatch({ "type": "LOADER_SHOW" });
		},
		clearError: () => {
			dispatch({ "type": "LOGIN_SET_ERROR", "error": false, "errorMsj": "" });
		},
		setError: (error) => {
			dispatch({ "type": "LOGIN_SET_ERROR", "error": true, "mensaje": error });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		},
		eventoCerrar: (dispositivo) => {
			dispatch({ "type": "EVENT_UMIGRADO_INICIARSESION_BACEPTAR", "flujo": "UsuarioMigrado", "dispositivo": dispositivo });
		}
	};
};

const campoSettings = {
	fontFamily: 'Open Sans',
	fontStyle: 'normal',
	fontWeight: 'normal',
	mixBlendMode: 'normal',
}

const floatingLabelStyleSettings = {
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.5px',
	color: '#0C2040',
}

const floatingLabelFocusStyleSettings = {
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.5px',
	color: '#FF6B0B',
}

const campo = ({ input, label, max, type, focus, error }) => {
	return (
		<MuiThemeProvider>
			<TextField
				{...input}
				floatingLabelText={label}
				fullWidth={true}
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				type={type}
				onFocus={focus}
				onBlur={(event) => { input.onBlur(event); }}
				onChange={(event) => { input.onChange(event); }}
				maxLength={max}
				errorText={error}
			/>
		</MuiThemeProvider>
	);
};

class IngresaCorreo extends React.Component {

	idOperacionOTP = "";
	codigoOtpRecibido = "";
	arrayCodigosOtp = [];
	state = {
		inputTypeUsr: "text",
		inputTypePwd: "password",
		inputClassUsr: "input-wrap ver-input mt-38",
		inputClassPwd: "input-wrap ver-input mt-38",
		inputActiveUsr: "",
		inputActivePwd: "",
		error: false,
		errorMsj: "",
		errorMsjPwd: "",
		email: "",
		emailSecreto: "",
		bloqueado: false,
		check: false,
		classBtn: "orange-rectangle disabled",
		pass: "",
		MsjTiempoRestante: true,
		MsjExpira: false,
		msjErrorCodigo: false,
		msjExitoReenvio: false,
		msjErrorServicio: false,
		btnValidarHabilitado: true,
		celular: "",
		celularSecreto: "",
		cveUnico: "",
		loadingPequeno1: true,
	}

	componentWillMount = () => {
		console.log("Ya cargo el componente");

		localStorage.removeItem("UsuarioExisteB");
		localStorage.removeItem("detallePoliza");
		localStorage.removeItem("planesSubplanesGNP");
		localStorage.removeItem("planesCliente");
		localStorage.removeItem("planesGNP");
		localStorage.removeItem("banConcluirReg");
		localStorage.removeItem("banConcluirRegPoliza");
		localStorage.removeItem("banderacorreo");
		localStorage.removeItem("correoG");

		if (localStorage.getItem("cancelarRegInc") === 'true') {
			this.setState({ email: "" });
			this.props.setCorreo("");
			localStorage.removeItem("cancelarRegInc");
		} else {
			console.log('listo');
		}

		let correo = window.localStorage.getItem("correoSoyCliente");
		if (correo !== null) {
			console.log("Si tiene recordar usuario correo: " + correo);
			this.setState({ check: true });
			this.setState({ email: correo });
			this.props.setCorreo(correo);
			this.props.pasoSiguiente(correo, this.props.dispositivo);
		} else {
			console.log('listo');
		}
	}

	validateEmail = (email) => {
		email = email.toLowerCase();
		const pattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		return pattern.test(email);
	}

	changeInputTypeUsr = () => {
		let type = this.state.inputTypeUsr;
		this.setState({ inputTypeUsr: type === "password" ? "text" : "password" });
		this.setState({ inputClassUsr: type === "password" ? "input-wrap visible-input mt-38" : "input-wrap ver-input mt-38" });
	}

	changeInputTypePwd = () => {
		let type = this.state.inputTypePwd;
		this.setState({ inputTypePwd: type === "password" ? "text" : "password" });
		this.setState({ inputClassPwd: type === "password" ? "input-wrap visible-input mt-38" : "input-wrap ver-input mt-38" });
	}

	validarEmail = () => {
		this.setState({ bloqueado: true });
		this.setState({ classBtn: "orange-rectangle" });

		if (!this.props.loader && !this.state.bloqueado) {
			this.setState({ error: false });
			this.setState({ errorMsj: "" });
			this.props.clearError();
			let email = $("#correo-login").val();
			email = email.toLowerCase();

			if (!email) {
				this.props.setError("Campo requerido.");
				this.setState({ bloqueado: false });
				this.setState({ classBtn: "orange-rectangle disabled" });
				return;
			} else if (!this.validateEmail(email)) {
				this.props.setError("Formato de correo inválido. Intenta nuevamente.");
				this.props.clearSecreto();
				this.setState({ bloqueado: false });
				this.setState({ classBtn: "orange-rectangle disabled" });
				return;
			} else {
				this.props.setCorreo(email);
				this.props.showLoader();
				this.props.setPreguntaUno({ t: "aoehanotehanotehn", id: "aoeaoe" });
				this.props.setPreguntaDos({ t: "aoehanotehanotehn", id: "aoeaoe" });
				this.setState({ bloqueado: false });
				this.props.pasoSiguiente(email, this.props.dispositivo);
			}
		}
	}

	validarPass = () => {
		console.log("Validar pass");

		let $this = this;
		$this.props.loader(true);
		localStorage.removeItem("planesCliente");
		localStorage.removeItem("planesGNP");
		localStorage.removeItem("esCliente");
		localStorage.removeItem("clienteUnico");
		localStorage.removeItem("inactividad");
		this.setState({ bloqueado: true });
		let email = $("#correo-login").val();
		let pass = $("#pass-login").val();
		this.setState({ classBtn: "orange-rectangle" });

		if (!email) {
			this.props.setError("Campo requerido.");
			this.setState({ bloqueado: false });
			this.setState({ classBtn: "orange-rectangle disabled" });
		}

		if (!pass) {
			$this.props.loader(false);
			this.setState({ error: true });
			this.setState({ errorMsjPwd: "Campo requerido." });
			this.props.addEvento("Bienvenido-CampoRequerido");
			this.props.tagManager({ "type": "EVENT_LOGIN_BIENVENIDO-VACIOS", "dispositivo": this.props.dispositivo });
			this.setState({ bloqueado: false });
			this.setState({ classBtn: "orange-rectangle disabled" });
		}

		if (email && pass) {
			this.props.setPass(pass);
			localStorage.setItem("cveCliente", this.props.cveCliente);
			localStorage.setItem("inactividad", true);

			validarPass(this.props.cveCliente, this.props.correo, pass).then((response) => response.json()).then((responseJson) => {
				console.log("Respuesta", responseJson.hasOwnProperty("jwt"));

				if (responseJson.hasOwnProperty("jwt")) {
					authentication.signOut().then(function () {
						let remember = document.getElementById('recordar');
						if (remember.checked) {
							window.localStorage.setItem("correoSoyCliente", email);
						}
						else {
							window.localStorage.removeItem("correoSoyCliente");
						}
						authentication.signInWithCustomToken(responseJson.jwt).then(function (result) {
							$this.props.eventoCorrectos($this.props.dispositivo);
							localStorage.setItem("refreshToken", responseJson.refreshtoken);
							if ($this.props.accesoFamiliar !== false) {
								$this.altaAccesoFamiliar();
							} else {
								goTo("home");
								this.props.tagManager({
									"type": "EVENT_LOGIN_INICIAR_SESION", "dispositivo": this.props.dispositivo
								});
							}
						}).catch(function (error) {
							console.log("error", error);
							$this.props.loader(false);
						});
					}, function (error) {
						console.error("Sign Out Error", error);
					});

				} else if (responseJson.hasOwnProperty("sesion")) {
					$this.props.loader(false);
					$this.setState({ bloqueado: false });
					this.props.tagManager({ "type": "EVENT_LOGIN_SESION-ACTIVA", "dispositivo": this.props.dispositivo });
					this.props.aviso("Ya cuentas con una sesión abierta, finaliza tu sesión activa para poder ingresar nuevamente.");
				} else if (responseJson.hasOwnProperty("errormedios")) {
					$this.props.loader(false);
					$this.setState({ bloqueado: false });
					this.props.alertaAccion("Servicio no disponible, favor de intentarlo más tarde.");
				} else if (responseJson.hasOwnProperty("preguntas")) {
					$this.props.loader(false);

					if (!responseJson.preguntas) {
						$("#modal-primer-error").modal("toggle");
						$this.refs.inputContrasena.value = "";
						$this.setState({ pass: "" });
						$this.props.tagManager({ "type": "EVENT_LOGIN_BIENVENIDO-INCORRECTOS", "dispositivo": $this.props.dispositivo });
					} else {
						this.modalUsuarioBloqueado();
					}
				} else if (responseJson.hasOwnProperty("estatusCliente") && responseJson.estatusCliente === "Inactivo") {
					$this.props.loader(false);
					this.modalUsuarioBloqueado();
					$this.props.clearSecreto();
				} else if (responseJson.hasOwnProperty("estatusCliente") && responseJson.estatusCliente === "InactivoAnio") {
					console.log("Usuario bloqueado");
					$this.props.loader(false);
					this.modalUsuarioBloqueado();
					$this.props.clearSecreto();
				} else if (responseJson.hasOwnProperty("estatusCliente") && responseJson.estatusCliente === "Blacklist") {
					$this.props.loader(false);
					$("#modal-blacklist").modal("toggle");
				} else if (responseJson.hasOwnProperty("estatusCliente") && responseJson.estatusCliente === "Incompleto") {
					$this.props.loader(false);
					$("#modal-user-incompleto").modal("toggle");
				} else if (responseJson.hasOwnProperty("estatusCliente") && responseJson.estatusCliente === "Contratos") {
					$this.props.loader(false);
					$this.props.setClaveCliente(responseJson.cveCliente);
					$("#modal-contrato").modal("toggle");
				} else {
					$this.props.loader(false);
					$this.props.alertaAccion("Hubo un error al Loguearse. Favor de intentar más tarde.", () => {
						$this.regresar();
					});
				}
			}).catch((validarPassError) => {
				console.log("validarPassError", validarPassError);
				$this.props.loader(false);
				$this.props.alertaAccion("Hubo un error al Loguearse. Favor de intentar más tarde.");
			});
		} else {
			$this.props.loader(false);
		}
	}

	handleBlurUsr = () => {
		localStorage.removeItem("UsuarioExisteB");
		let mail = $("#correo-login").val().replace(/\s/g, "");
		this.setState({ email: mail });
		this.setState({ inputActiveUsr: mail ? "input-active" : "" });
		this.setState({ error: false });
		this.setState({ errorMsj: "" });
		this.props.clearError();
		let email = $("#correo-login").val();
		$("#correo-login").val(email);

		if (email.length > 1) {
			this.setState({ classBtn: "orange-rectangle" });
			if (!this.validateEmail(email)) {
				this.setState({ classBtn: "orange-rectangle disabled" });
				this.setState({ bloqueado: false });
				this.props.setError("Formato de correo inválido. Intenta nuevamente.");
				this.props.clearSecreto();
			}
			else {
				this.props.setCorreo(email);
				localStorage.setItem("correoG", email);
				this.props.pasoSiguiente(email, this.props.dispositivo);
			}
		} else {
			this.setState({ email: "" });
			this.props.setCorreo("");
		}
	}

	handleBlurPwd = (event) => {
		let pass = event.target.value;
		this.setState({ inputActivePwd: pass ? "input-active" : "" });
		if (pass.length > 1) {
			this.setState({ classBtn: "orange-rectangle" });
		}
		else {
			this.setState({ classBtn: "orange-rectangle disabled" });
		}
	}

	handleChange = () => {
		this.setState({ bloqueado: false });
	}

	handleFocusUsr = () => {
		this.setState({ inputActiveUsr: "input-active" });
		this.setState({ error: false });
		this.setState({ errorMsj: "" });
		this.props.clearError();
	}

	handleFocusPwd = (event) => {
		this.setState({ inputActivePwd: "input-active" });
		this.setState({ errorMsjPwd: "" });
		if (this.state.error) {
			this.setState({ pass: "" });
			event.target.value = "";
		}
		this.setState({ error: false });
	}

	_handleKeyPressUsr = (event) => {
		if (event.key === "Enter") {
			if (!this.state.bloqueado) {
				this.setState({ bloqueado: true });
				this.validarEmail();
			}
		}
	}

	_handleKeyPressPwd = (event) => {
		this.setState({ error: false });
		this.setState({ errorMsjPwd: "" });
		if (event.key === "Enter") {
			this.setState({ bloqueado: true });
			if (!this.state.bloqueado) {
				let pass = event.target.value;
				if (!pass) {
					this.setState({ error: true });
					this.setState({ errorMsjPwd: "Campo requerido." });
					this.setState({ bloqueado: false });
					return;
				}
				this.validarPass();
			}
		}
	}

	regresar = () => {
		this.props.tagManager({ "type": "EVENT_LOGIN_BIENVENIDO_NO-SOY-YO", "dispositivo": this.props.dispositivo });
		this.setState({ pass: "" });
		this.refs.inputContrasena.value = "";
		this.setState({ bloqueado: false });
		this.props.pasoAnterior();
	}

	altaAccesoFamiliar = () => {
		let $this = this;
		new callService({
			service: "accesoFamiliar.loginInvitacion",
			secure: true,
			data: {
				hashOne: this.props.hashOne,
				hashTwo: this.props.hashTwo,
				email: this.props.accesoFamiliar
			}
		}).execute().then((respuesta) => {
			console.log("respuesta", respuesta);
			$this.props.resetAccesoFamiliar();
			goTo("home");
		}).catch((error) => {
			$this.props.loader(false);
			$this.props.alertaAccion(error.message.mensaje, () => {
				goTo("home");
			});
		});
	}

	siguientePregunta = () => {
		$("#modal-primer-error").modal("toggle");
		this.setState({ pass: "" });
		this.refs.inputContrasena.value = "";
		this.setState({ bloqueado: false });
		this.props.incrementaIntento();
	}

	goToPreguntas = () => {
		this.props.tagManager({ "type": "EVENT_LOGIN_UNO_CUENTABLOQUEADA-ACEPTAR", "dispositivo": this.props.dispositivo });
		localStorage.setItem("inactividad", true);
		$("#modal-bloqueado").modal("toggle");
		this.props.setPaso(2);
	}

	goToLogin = () => {
		$("#modal-blacklist").modal("toggle");
		this.props.resetPaso();
	}

	goToPreguntasInactividad = () => {
		localStorage.setItem("inactividad", true);
		// GOOGLE TAG MANAGER //
		this.props.tagManager({ "type": "EVENT_LOGIN_UNO_CUENTABLOQUEADA-ACEPTAR", "dispositivo": this.props.dispositivo });
		$("#modal-inactividad").modal("toggle");
		this.props.setPaso(2);
	}

	goToOlvide = () => {
		$("#modal-user-incompleto").modal("toggle");
		this.props.resetPaso();
	}

	modalUsuarioBloqueado = () => {
		new callService({
			service: 'registro.obtenerNombreMedios',
			"secure": true,
			data: { email: localStorage.getItem("correoG") }
		}).execute().then(body => {
			const uid = body.cveClienteUnico;

			new callService({
				service: "registro.obtenerurlregistro",
				secure: false,
				data: { valor: uid, encripta: false }
			}).execute().then(resp1 => {

				new callService({
					service: "login.suspenderMedios",
					secure: true,
					data: { uid: resp1.hash }
				}).execute().then(resp2 => {
					console.log("RESPUESTA", resp2);
				}).catch(error => {
					console.log("error", error);
				});

			}).catch(error => {
				console.log("error", error);
			});
		}).catch(error => {
			console.log('error', error);
		});

		setTimeout(() => {
			$(modalNuevoDesbloqueado).modal("toggle");
		}, 2000)
	}

	cancelaContrato = () => {
		$("#modal-contrato").modal("toggle");
		this.props.resetPaso();
		goTo("login");
	}

	aceptaContrato = () => {
		let $this = this;
		$("#modal-contrato").modal("toggle");
		$this.props.loader(true);
		aceptoContrato(this.props.uid, this.props.email, this.props.pass).then((response) => response.json()).then((responseJson) => {
			if (responseJson.hasOwnProperty("jwt")) {
				authentication.signOut().then(function () {
					authentication.signInWithCustomToken(responseJson.jwt).then(function (result) {
						localStorage.setItem("refreshToken", responseJson.refreshtoken);
						goTo("home");
					}).catch(function (error) {
						$this.props.loader(false);
					});
				}, function (error) {
					console.error("Sign Out Error", error);
				});
			} else {
				this.props.alertaAccion("Hubo un error al Loguearse. Favor de intentar más tarde.");
			}
		});
	}

	componentDidMount = () => {
		const cuentaEliminada = localStorage.getItem("cuentaEliminada");

		if (cuentaEliminada === "true") {
			this.muestraTooltip(true, 'exito', "Cuenta eliminada", "Tu cuenta fue eliminada exitosamente");
		} else {
			this.muestraTooltip(false, "", "", "");
			localStorage.removeItem("cuentaEliminada");
		}

		this.setState({ email: "" });
		this.props.setCorreo("");
		this.props.clearSecreto();
		var passw = document.getElementById("pass-login");
		passw.onpaste = function (e) {
			try { e.preventDefault(); } catch (o) { }
		};
	}

	enmascara = () => {
		let x;
		let charOrig, charMask;
		const lengthCad = $("#pass-login").val().length;
		let hide = "";
		let show = "";
		for (x = 0; x < lengthCad - 1; x++) {
			$("#pass-login").val()
			charMask = $("#pass-login").val().charAt(x);
			charOrig = this.state.pass.charAt(x);
			if (charMask != unescape("%u25CF")) {
				hide += charMask;
				show += unescape("%u25CF");
			} else {
				hide += charOrig;
				if (charOrig != "") {
					show += unescape("%u25CF");
				}
			}
		}
		if ($("#pass-login").val().charAt(x) !== unescape("%u25CF")) {
			hide += $("#pass-login").val().charAt(x);
			show += $("#pass-login").val().charAt(x);
		}
		else {
			hide += this.state.pass.charAt(x);
			show += $("#pass-login").val().charAt(x);
		}
		this.setState({ pass: hide });
		$("#pass-login").val(show);
		clearTimeout(timer);
		timer = setTimeout(function () {
			let temp = "";
			for (x = 0; x < lengthCad; x++) {
				temp += unescape("%u25CF");
			}
			$("#pass-login").val(temp);
		}, 1000);
	}

	cerrarModal = () => {
		$("#modal-revisa-correo").modal("hide");
		this.props.eventoCerrar(this.props.dispositivo);
	}

	ir = (sRuta) => {
		this.limpiarLogin();
		goTo(sRuta);
	}

	olvide = () => {
		goTo("gnp/gnp-olvide-contrasenia");
	}

	limpiarLogin = () => {
		document.getElementById("correo-login").value = "";
		document.getElementById("pass-login").value = "";
		this.props.clearSecreto();
		this.setState({ bloqueado: true });
	}

	registrate = () => {
		localStorage.removeItem("aceptarAviso");
		localStorage.removeItem("mediosElectronicos");
		this.props.tagManager({ "type": "EVENT_REGISTRO_REGISTRATE-AHORA", "dispositivo": this.props.dispositivo });
		$("#correo-login").val("");
		this.setState({ error: false });
		this.setState({ errorMsj: "" });
		this.setState({ errorMsjPwd: "" });
		this.props.clearError();
		goTo("gnp/registro");
	}

	cancelarModal = () => {
		console.log("cancelar");
		$(modalNuevoDesbloqueado).modal("hide");
		this.props.resetPaso();
		goTo("login");
	}

	cancelarModalError = () => {
		console.log("cancelar");
		$(modalErrorDesbloqueo).modal("hide");
		this.props.resetPaso();
		goTo("login");
	}

	goToOTP = () => {
		this.props.loader(true);
		const correo = this.props.correo

		new callService({
			service: "registro.obtenerNombreMedios",
			secure: true,
			data: {
				email: correo.toLowerCase()
			}
		}).execute().then((respuesta) => {
			console.log("respuesta servicio", respuesta);
			this.props.change("celular", respuesta.telefono);
			this.setState({ celular: respuesta.telefono });
			this.setState({ cveUnico: respuesta.cveClienteUnico });
			this.generarOtp();
		}).catch((error) => {
			this.props.loader(false);
			console.log("Error", error);
		});
	}

	codigoCompleto = (e) => {
		console.log("codigo: ", e.target.value);
		const inputCodigo = document.getElementsByName('codigo_verificacion')[0].value;

		if (/^[0-9]+/.test(inputCodigo) && inputCodigo.length === 8) {
			this.msjaMostrar = "";
			this.errorsCodigo = false;
			this.setState({ btnValidarHabilitado: false })
		} else {
			console.log("else otp");
		}
	}

	generarOtp = () => {
		this.separaCorreo();
		this.separaTelefono();
		const cveU = this.state.cveUnico;
		this.quitarMsjErrorCodigo(false);
		this.quitarmsjErrorServicio(false);
		this.quitarMsjExpiro(false);
		this.btnHabilitado = false;
		this.quitarMsjTiempoRestante(true);
		document.getElementsByName('codigo_verificacion')[0].value = "";

		new callService({
			service: 'otp.obtenerOtpBan',
			"secure": true,
			data: { clienteUnico: cveU }
		}).execute().then(body => {
			console.log("body en generar otp", body);
			if (body.enviarOtpResponse.resultado) {
				this.idOperacionOTP = body.enviarOtpResponse.idOperacion;
				this.codigoOtpRecibido = body.enviarOtpResponse.codOtp;
				this.props.loader(false);
				$(modalNuevoDesbloqueado).modal("hide");
				$(nombreModalOTP).modal("toggle");
				this.startTimer();
			} else {
				this.props.loader(false);
				$(modalNuevoDesbloqueado).modal("hide");
				$(modalErrorDesbloqueo).modal("toggle");
				console.log('error');
			}
		}).catch(error => {
			console.log(error);
			this.quitarmsjErrorServicio(true);
		});

		setTimeout(() => {
			console.log("tiempo 4s");
			this.props.loader(false);
		}, 4000);
	}

	mostrarSpinner = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ loadingPequeno: true });
			}, 500);
		} else {
			setTimeout(() => {
				this.setState({ loadingPequeno: false });
			}, 500);
		}
	}

	reenviarOtp = () => {
		const cveU = this.state.cveUnico;
		console.log("cve", cveU);
		this.arrayCodigosOtp.push(this.codigoOtpRecibido);
		this.mostrarSpinner(true);
		this.quitarmsjErrorServicio(false);
		new callService({
			service: 'otp.obtenerOtpBan',
			"secure": true,
			data: { clienteUnico: cveU }
		}).execute().then(body => {
			this.idOperacionOTP = "";
			this.codigoOtpRecibido = "";
			console.log(this.codigoOtpRecibido);
			if (body.enviarOtpResponse.resultado) {
				this.idOperacionOTP = body.enviarOtpResponse.idOperacion;
				this.codigoOtpRecibido = body.enviarOtpResponse.codOtp;
				console.log(this.codigoOtpRecibido);
				this.mostrarSpinner(false);
				this.quitarmsjReenvio(true);
				this.resetTimer();
			} else {
				this.mostrarSpinner(false);
				console.log('error');
			}
		}).catch(error => {
			this.mostrarSpinner(false);
			console.log(error);
			this.quitarmsjErrorServicio(true);
		});
	}

	separaCorreo = () => {
		let email = this.state.email
		const dominio = email.substring(email.indexOf("@", 0), email.length)

		console.log("email,", email, dominio);

		email = email.substring(0, email.indexOf("@", 0));
		let element = "";
		for (let index = 0; index < email.length - 5; index++) {
			element += '•';
		}

		this.setState({ emailSecreto: element + email.substring(email.length - 5, email.length) + dominio });
		console.log("emailSe,", this.state.emailSecreto);
	}

	separaTelefono = () => {
		const celular = this.state.celular;
		console.log("celular", celular);

		if (celular !== null) {
			const ultimod = celular.substring(5, celular.length)
			let element = "";
			for (let index = 0; index < celular.length - 5; index++) {
				element += '•';
			}
			this.setState({ celularSecreto: element + ultimod });
		} else {
			console.log("No tiene numero celular");
		}

	}

	quitarMsjTiempoRestante = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ MsjTiempoRestante: bandera })
			}, 100);
		} else {
			this.setState({ MsjTiempoRestante: bandera })
		}
	}

	quitarMsjExpiro = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ MsjExpira: bandera })
			}, 1000);
		} else {
			this.setState({ MsjExpira: bandera })
		}
	}

	quitarMsjErrorCodigo = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ msjErrorCodigo: bandera })
			}, 1000);
		} else {
			this.setState({ msjErrorCodigo: bandera })
		}
	}

	quitarmsjReenvio = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ msjExitoReenvio: true })
			}, 500);
		} else {
			setTimeout(() => {
				this.setState({ msjExitoReenvio: false })
			}, 500);
		}
	}

	quitarmsjErrorServicio = (bandera) => {
		if (bandera) {
			setTimeout(() => {
				this.setState({ msjErrorServicio: bandera })
			}, 500);
		} else {
			this.setState({ msjErrorServicio: bandera })
		}
	}

	validarCodOtp = () => {
		this.setState({ loadingPequeno1: true });

		this.quitarMsjErrorCodigo(false);
		this.quitarMsjExpiro(false);
		this.quitarmsjErrorServicio(false);
		const codigo = document.getElementsByName('codigo_verificacion')[0].value;
		if (this.arrayCodigosOtp.length > 0 && this.arrayCodigosOtp.includes(codigo)) {
			this.quitarMsjErrorCodigo(true);
			this.quitarMsjExpiro(false);
		} else {
			new callService({
				service: "registro.validarOtpBanRegistro",
				secure: true,
				data: { codigo: codigo, operacion: this.idOperacionOTP },
			}).execute().then(body => {
				console.log("body:", body);
				if (body.tipo === "exito") {
					this.uidEncriptado(this.state.cveUnico);
				} else if (body.tipo === "otro") {
					this.setState({ loadingPequeno1: false });
					this.setState({ msjErrorCodigo: true })
				}
			}).catch(error => {
				this.setState({ loadingPequeno1: false });
				this.quitarMsjExpiro(false);
			});
		}
	}

	uidEncriptado = (uid) => {
		$(nombreModalOTP).modal("hide");
		new callService({
			service: "registro.obtenerurlregistro",
			secure: false,
			data: { valor: uid }
		}).execute().then(resp => {
			const llamaServicio = new callService({
				service: "login.desbloqueoMedios",
				secure: true, data: { "uid": resp.hash }
			}).execute();
			llamaServicio.then((respuesta) => {
				console.log("respuesta de desbloquearMedios:", respuesta);

				setTimeout(() => {
					this.props.loader(false);
				}, 2000);

				$("#modal-desbloqueado").modal("toggle");
			}).catch((error) => {
				console.log("error", error);

				setTimeout(() => {
					this.props.loader(false);
				}, 2000);

				$(modalErrorDesbloqueo).modal("toggle");
			});
		}).catch(error => {
			this.props.loader(false);
			console.log("error al encriptar el valor correo", error);
		});
	}

	startTimer = () => {
		if (!this.interval) {
			function pad(val) {
				return val > 9 ? val : "0" + val;
			}
			this.interval = setInterval(function () {
				totalSeconds -= 1;
				if (totalSeconds > 0) {
					document.getElementById(TemporizadoOTP).innerText = 'Válido por ' + pad(Math.floor(totalSeconds / 60 % 60)) + ":" + pad(parseInt(totalSeconds % 60)) + ' minutos';
				} else {
					document.getElementById(TemporizadoOTP).innerText = 'Válido por 00:00 minutos';
				}
			}, 1000);
		}
	}

	resetTimer = () => {
		totalSeconds = 420;
		clearInterval(this.interval);
		document.getElementById(TemporizadoOTP).innerText = "";
		delete this.interval;
		this.startTimer();
	}

	muestraTooltip = (show, type?, titulo?, mensaje?) => {
		setTimeout(() => {
			this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
		}, 300);
	}

	cierraTooltip = e => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
	}

	redireccion = e => {
		console.log("HOLA");
	}

	cerrarModal = () => {
		$(nombreModalOTP).modal('hide');
		$(idModal).modal('hide');
	}

	render() {
		const modalOtp = "modal-otp";
		const codVerif = "Código de verificación";
		return <div className="login-form">

			<div className="login-form">

				<div style={{ marginLeft: "580px" }}>
					<ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
						show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
					</ModalSintillo>
				</div>

				<div style={{ marginLeft: "580px" }}>
					<CintilloNuevo onClose={this.redireccion} titulo={"Nos inovamos para brindarte un mejor servicio."}
						show={true} mensaje={"Mensaje"}>
					</CintilloNuevo>
				</div>

				<div className="h1-titulo">Iniciar sesión</div>
				{this.props.secreto !== "" && this.props.email !== "" &&
					<div style={{
						"position": "absolute", "margin-left": "auto", "margin-right": "auto",
						"left": "0", "right": "0", "text-align": "center"
					}} >
						<h3 style={{ "margin-bottom": "0px", "margin-top": "0px" }}>¡Bienvenido(a) {this.props.secreto}!</h3>
					</div>
				}
				<div className="input-wrap mt-38" style={{ "margin-bottom": "20px", "margin-top": "50px" }}>
					<label>Correo electrónico</label>
					<span className="input-active">
						<input id="correo-login" autoFocus aria-label="Correo electronico" defaultValue={this.state.email} name="correo" disabled={true}
							type={this.state.inputTypeUsr} onBlur={this.handleBlurUsr} onFocus={this.handleFocusUsr} onKeyPress={this._handleKeyPressUsr} />
					</span>
					{this.state.error &&
						<div className="error-wrap">
							<div className="msj-error">
								{this.state.errorMsj}
							</div>
						</div>
					}
					{this.props.mensaje !== "" &&
						<div className="error-wrap">
							<div className="msj-error">
								{this.props.mensaje}
							</div>
						</div>
					}
				</div>

				<div className={this.state.inputClassPwd} style={{ "margin-bottom": "0px", "margin-top": "5px" }}>
					<label>Contraseña</label>
					<span className="input-active">
						<input id="pass-login" maxLength="24" ref="inputContrasena" name="contrasenia" type={this.state.inputTypePwd}
							onBlur={this.handleBlurPwd} onFocus={this.handleFocusPwd} onChange={this.handleChange} onKeyUp={this._handleKeyPressPwd} disabled={true}
						/>
						<button aria-label="Ver password" name="contrasenia" className="btn-ojo" onClick={this.changeInputTypePwd} >
							<i></i>
						</button>
					</span>
					{this.state.error &&
						<div className="error-wrap">
							<div className="msj-error">
								{this.state.errorMsjPwd}
							</div>
						</div>
					}
				</div>

				<div style={{ "display": "flex", "margin-bottom": "-10px", "margin-top": "30px" }}>
					<input type="checkbox" id="recordar" name="recordar" ref="recordar"
						defaultChecked={this.state.check} style={{ "margin": "0px 3px 0px 0px" }}
					/>
					Recordar usuario
				</div>
				<div className="text-center mt-30">
					<button ref="boton" onClick={this.validarPass} disabled={true} className={this.state.classBtn}>Entrar</button>
				</div>
			</div>

			<div className="text-center mt-15">
				<a className="azul-italic" onClick={this.redireccion} name="olvide" disabled={true}>Olvidé mi contraseña</a> <br />
			</div>

			<div className="text-center mt-15">
				¿No tienes cuenta? <a className="azul-italic" onClick={this.redireccion} name="registro" disabled={true}>Regístrate ahora</a><br />
				¿Eres tercero o un gestor? <a className="azul-italic" href={servicios.login.portalAutoservicioLogin} target="_blank" name="tercero-gestor" disabled={true}>Ingresa aquí</a>
			</div>

			<div className="text-center mt-15"></div>

			<div className="modal fade modal-msj" id="modal-revisa-correo" tabIndex="-1" role="dialog" aria-labelledby="modal-revisa-correo" data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="login-form">
							<div>
								<h5 className="text-center" id="modal-revisa-correoLabel">Importante</h5>
							</div>
							<div className="txt-black">
								<p>Las condiciones del uso del Portal han cambiado, por tu seguridad deberás completar algunos datos y crear una nueva contraseña. Se te ha enviado un correo electrónico a {this.state.email}. Si no ves el correo electrónico en tu bandeja de entrada revisa otros lugares en dónde podría estar como  el spam</p>
							</div>
							<div className="mt-70"><button onClick={this.cerrarModal} className="orange-rectangle">Aceptar</button></div>
							<div className="gray-text text-right mt-70"></div>
						</div>

					</div>
				</div>
			</div>

			<div className="modal fade" id="modal-primer-error" tabIndex="-1" role="dialog" aria-labelledby="modal-primer-errorLabel" data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="">
							<h4 className="" id="modal-primer-errorLabel">Contraseña incorrecta</h4>
						</div>
						<div className="text-center">
							<p>Vuelve a ingresar tu contraseña.</p>
							<p>Por tu seguridad se bloqueará después de tres intentos fallidos.</p>
						</div>
						<div className="">
							<button type="button" className="btn orange-btn" onClick={this.siguientePregunta}>Aceptar</button>
						</div>
					</div>
				</div>
			</div>

			<div className="modal modal-msj fade" id="modal-bloqueado" tabIndex="-1" role="dialog" aria-labelledby="modal-bloqueadoLabel" data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div>
							<h5 className="text-center" id="modal-bloqueadoLabel">Cuenta bloqueada</h5>
						</div>
						<div className="txt-black">
							<p>{mensaje1}<br />{mensaje2}<br />
								{mensaje3}</p>
						</div>
						<div className="text-center aceptar-cancelar-btn mt-20">
							<button type="button" className="btn orange-btn" onClick={this.goToPreguntas}>Aceptar</button>
						</div>
					</div>
				</div>
			</div>

			<div className="modal modal-msj fade" id="modal-user-bloqueado" tabIndex="-1" role="dialog" aria-labelledby="modal-user-bloqueadoLabel" data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div>
							<h5 className="text-center" id="modal-user-bloqueadoLabel">Cuenta bloqueada</h5>
						</div>
						<div className="txt-black">
							<p>{mensaje1}<br />
								{mensaje2}<br />
								{mensaje3}</p>
						</div>
						<div className="text-center aceptar-cancelar-btn mt-20">
							<button type="button" className="btn orange-btn" onClick={this.goToPreguntas}>Aceptar</button>
						</div>
					</div>
				</div>
			</div>

			<div className="modal modal-msj fade" id="modal-blacklist" tabIndex="-1" role="dialog" aria-labelledby="modal-blacklistLabel" data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div>
							<h5 className="text-center" id="modal-blacklistLabel">Su cuenta está en mantenimiento</h5>
						</div>
						<div className="txt-black">
							Agradecemos su comprensión, estamos trabajando para mejorar su experiencia. <br /> Si requiere de algún tramite, por favor comunicarse a la Línea GNP. <br />
						</div>
						<div className="text-center aceptar-cancelar-btn mt-20">
							<button type="submit" className="orange-btn" style={{ "margin": "25px auto 0px auto", "display": "block" }} onClick={this.goToLogin}>Aceptar</button>
						</div>
					</div>
				</div>
			</div>

			<div className="modal modal-msj fade" id="modal-inactividad" tabIndex="-1" role="dialog" aria-labelledby="modal-inactividadLabel" data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div>
							<h5 className="text-center" id="modal-inactividadLabel">Inactividad</h5>
						</div>
						<div className="txt-black">
							<p>{mensaje1}<br />
								{mensaje2}<br />
								{mensaje3}</p>
						</div>
						<div className="text-center aceptar-cancelar-btn mt-20">
							<button type="submit" className="orange-btn"
								style={{ "margin": "25px auto 0px auto", "display": "block" }}
								onClick={this.goToPreguntasInactividad}>Preguntas secretas</button>
						</div>
					</div>
				</div>
			</div>

			<div className="modal modal-msj fade" id="modal-contrato" tabIndex="-1" role="dialog" aria-labelledby="modal-contratoLabel" data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div>
							<h5 className="text-center" id="modal-contratoLabel">Aviso</h5>
						</div>
						<div className="txt-black">
							Estimado cliente, el contrato de Uso de Medios Electrónicos ha sido modificado, lo invitamos a consultarlo en este portal
						</div>
						<div className="text-center aceptar-cancelar-btn mt-20">
							<a onClick={this.cancelaContrato}>Cancelar</a>
							<a className="orange-btn" onClick={this.aceptaContrato}>Aceptar</a>
						</div>
					</div>
				</div>
			</div>

			<div className="modal modal-msj fade" id="modal-user-incompleto" tabIndex="-1" role="dialog" aria-labelledby="modal-user-incompletoLabel" data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div>
							<h5 className="text-center" id="modal-user-incompletoLabel">Importante</h5>
						</div>
						<div className="txt-black">
							Se ha identificado que el proceso de registro no se completó correctamente, es necesario entrar a
							"Olvide mi contraseña" para que recibas un correo electrónico a tú cuenta para concluir el mismo.
						</div>
						<div className="text-center aceptar-cancelar-btn mt-20">
							<a className="orange-btn" onClick={this.goToOlvide}>Aceptar</a>
						</div>
					</div>
				</div>
			</div>

			<div className="modal modal-msj fade" id="modal-nuevo-bloqueado" tabIndex="-1" role="dialog" aria-labelledby="modal-bloqueadoLabel"
				data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-cabecera">
							<div className="icono">
								<span className='text-center icon-equis-circulo icono-modal-final' ></span>
							</div>

							<h5 className="text-center" id="modal-nuevo-bloqueadoLabel">Cuenta bloqueada</h5>
						</div>
						<div className="txt-black">
							<p>Tu cuenta ha sido bloqueada temporalmente debido a varios intentos de inicio de sesión
								incorrectos. Solicita tu verificación por SMS y recibe un código de verificación (OTP)
								para cambiar tu contraseña.</p>
						</div>
						<div className="text-center aceptar-cancelar-btn mt-20 opciones-bloqueo">
							<button type="button" className="btn orange-btn-large" onClick={this.goToOTP}>Solicitar código de verificación</button>
							<button type="button" className="btn white-btn" data-dismiss="modal" onClick={this.cancelarModal}>Cancelar</button>
						</div>
					</div>
				</div>
			</div>

			<div className="modal modal-msj fade" id="modal-error-desbloqueo" tabIndex="-1" role="dialog" aria-labelledby="modal-bloqueadoLabel"
				data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-cabecera">
							<button type="button" className="btn" data-dismiss="modal" onClick={this.cancelarModalError}>
								<div className="icono">
									<span className='text-center icon-equis-circulo icono-modal-final' ></span>
								</div>
							</button>
							<h5 className="text-center" id="modal-error-desbloqueoLabel">Error al desbloquear usuario</h5>
						</div>
						<div className="txt-black">
							<p>Intente de nuevo.</p>
						</div>
						<div className="text-center">
							<button type="button" className="btn orange-btn-large-2" data-dismiss="modal" onClick={this.cancelarModalError}>Cerrar</button>
						</div>
					</div>
				</div>
			</div>

			<div className="modal modal-msj fade" id="modal-desbloqueado" tabIndex="-1" role="dialog" aria-labelledby="modal-desbloqueadoLabel"
				data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-cabecera">
							<div className="icono">
								<span className='icon-circle-dove icono-modal-final' ></span>
							</div>

							<h5 className="text-center" id="modal-nuevo-bloqueadoLabel">Cuenta desbloqueda</h5>
						</div>
						<div className="txt-black">
							<p>¡Listo! Tu cuenta ha sido desbloqueda ingresa tu correo y
								contraseña nuevamente para acceder a tu cuenta.</p>
						</div>
						<div className="text-center aceptar-cancelar-btn-2 mt-20 opciones-bloqueo">
							<button type="button" className="btn orange-btn" data-dismiss="modal" style={{ "marginRight": "50px" }} onClick={this.ir.bind(this, "login")}>Iniciar sesión</button>
							<button type="button" className="btn orange-btn" data-dismiss="modal" onClick={this.olvide}>¿Olvidaste tu contraseña?</button>
						</div>
					</div>
				</div>
			</div>

			<div className="modal modal-msj fade" id="modal-OTP" tabIndex="-1" role="dialog" aria-labelledby="modal-desbloqueadoLabel"
				data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog modal-otp modal-otp-2" id="modal-otp-blq" role="document">
					<div className="modal-content modal-content-otp modal-content-otp-2">
						<span id="icon-equis-cerrar" onClick={this.cerrarModal}>X</span>
						<div className="modal-header-otp modal-header-otp-2">
							<h4 id={modalOtp} className="otp-titulo">{codVerif}</h4>
						</div>
						<div className="modal-body-otp modal-body-otp-2">
							<div className="modal-body-otp-title modal-body-otp-title-">
								<label>
									Ingresa el código de verificación que enviamos a tu
									correo electrónico {this.state.emailSecreto} y por SMS al
									número {this.state.celularSecreto}.
								</label>
								<label style={{ marginTop: "8px", "color": "#ff6b0b" }}>
									(+52) {this.state.celularSecreto}
								</label>

								<div className="input-wrap input-otp input-otp-2">
									<Field
										label={codVerif}
										name="codigo_verificacion" component={campo} type="text" max="8"
										onChange={this.codigoCompleto.bind(this)}
										error={this.errorsCodigo ? this.msjaMostrar : null}
									/>
								</div>
								{this.state.loadingPequeno1 ? <div className="spinner" style={{ marginLeft: "80%" }} id="spinner-validacion-poliza"></div> : null}

								{this.state.MsjTiempoRestante ?
									<div className="alerta-otp alerta-otp-2">
										<div> <span className="icon-warning" ></span> </div>
										<div className="alerta-body">
											<label className="label-title-alerta">{codVerif}</label>
											<label className="label-text-alerta" id={TemporizadoOTP}></label>
										</div>
										<div>
											<span className="icon-equis" style={{ 'cursor': 'pointer' }} onClick={this.quitarMsjTiempoRestante.bind(this, false)}></span>
										</div>
									</div> : null}
								{this.state.MsjExpira ?
									<div className="alerta-otp" style={{ "background": "#FDF3F5", "height": "auto" }}>
										<div>
											<span className="icon-equis-circulo" style={{ 'cursor': 'pointer' }} onClick={this.quitarMsjExpiro.bind(this, false)}></span>
										</div>
										<div className="alerta-body">
											<label className="label-title-alerta-error">{codVerif}</label>
											<label className="label-text-alerta">El código de verificación ha expirado, intente nuevamente</label>
										</div>
									</div> : null}
								{this.state.msjErrorServicio ?
									<div className="alerta-otp" style={{ "background": "#FDF3F5", "height": "auto" }}>
										<div>
											<span className="icon-equis-circulo" style={{ 'cursor': 'pointer' }} onClick={this.quitarmsjErrorServicio.bind(this, false)}></span>
										</div>
										<div className="alerta-body">
											<label className="label-title-alerta-error">Error</label>
											<label className="label-text-alerta">Ocurrio un error, intente más tarde.</label>
										</div>
									</div> : null}

								{this.state.msjErrorCodigo ?
									<div className="alerta-otp" style={{ "background": "#FDF3F5", "height": "auto" }}>
										<div>
											<span className="icon-equis-circulo" style={{ 'cursor': 'pointer' }} onClick={this.quitarMsjErrorCodigo.bind(this, false)}></span>
										</div>
										<div className="alerta-body">
											<label className="label-title-alerta-error">Error</label>
											<label className="label-text-alerta">El código de verificación no coincide.</label>
										</div>
									</div> : null}
								{this.state.msjExitoReenvio ?
									<div className="alerta-otp" style={{ height: 'auto', background: '#E3F5EB' }}>
										<div> <span className="icon-circle-dove" style={{ margin: '25px 8px' }}></span> </div>
										<div className="alerta-body">
											<label className="label-title-alerta" style={{ color: '#44956C' }}>CÓDIGO REENVIADO</label>
											<label className="label-text-alerta">Se ha reenviado el código exitosamente.</label>
										</div>
										<div>
											<span className="icono-cerrar-sintillo" style={{ 'cursor': 'pointer', color: '#44956C !important' }}
												onClick={this.quitarmsjReenvio.bind(this, false)}></span>
										</div>
									</div> : null}
								<div className="footer-modal-otp">
									<label>¿Tienes problemas? <span style={{ "color": "#ff6b0b", 'cursor': 'pointer' }}
										onClick={this.reenviarOtp.bind(this)}>
										Reenviar código</span>
										{this.state.loadingPequeno ? <div className="spinner" style={{ position: "absolute", right: '20px', marginTop: '-22px' }}
											id="spinner-validacion-poliza"></div> : null}
									</label>

									<div className="boton-text-final-otp">
										<button
											id="btn-validar"
											disabled={this.state.btnValidarHabilitado}
											style={{ "color": "#FFFFFF" }} type="button"
											className=" orange-btn texto-otp orange-btn-otp"
											onClick={this.validarCodOtp.bind(this)}
										>Validar</button>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>;
	}
}
IngresaCorreo = reduxForm({ form: "ingresa-correo" })(IngresaCorreo);
export default connect(mapState, mapDispatch)(IngresaCorreo);


// WEBPACK FOOTER //
// ./src/gnp-login/ingresaCorreo.cmpt.js